var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 48.9045 47.7817",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.0019 47.2827H1.90253C1.12742 47.2827 0.499025 46.6543 0.499025 45.8791C0.499025 42.7786 3.01252 40.2651 6.11306 40.2651H42.7914C45.892 40.2651 48.4055 42.7786 48.4055 45.8791C48.4055 46.6543 47.7771 47.2827 47.0019 47.2827Z",
    fill: "var(--fill-0, #B78E07)",
    stroke: "var(--stroke-0, #B78E07)",
    strokeWidth: 0.998051,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.64522 37.4581C2.80761 37.4581 0.499025 35.1495 0.499025 32.3119C0.499025 29.4743 2.80761 27.1657 5.64522 27.1657C8.48284 27.1657 10.7914 29.4743 10.7914 32.3119C10.7914 35.1495 8.48284 37.4581 5.64522 37.4581Z",
    fill: "var(--fill-0, #B78E07)",
    stroke: "var(--stroke-0, #B78E07)",
    strokeWidth: 0.998051,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M37.7751 28.5354V29.037H41.9859V26.1044L37.7751 28.5354Z",
    fill: "var(--fill-0, #B78E07)",
    stroke: "var(--stroke-0, #B78E07)",
    strokeWidth: 0.998051,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.5984 31.8441H34.968V26.9148L41.6176 23.0757C42.9422 22.311 43.4623 20.6259 42.7342 19.2809C41.9787 17.8853 40.2265 17.3963 38.8611 18.1845L30.7579 22.8629C29.8583 23.3824 29.367 24.3252 29.3661 25.2943H29.354V29.037H14.4405C13.9347 29.037 13.4498 29.1264 13.0005 29.2899C13.3959 30.2483 13.5991 31.2751 13.5984 32.3119C13.5984 33.9809 13.0806 35.5305 12.1988 36.8111C12.8697 37.2347 13.6471 37.4591 14.4405 37.4581H45.5401C47.0696 37.4581 48.3625 36.2588 48.4043 34.7299C48.4478 33.1436 47.175 31.8441 45.5984 31.8441Z",
    fill: "var(--fill-0, #B78E07)",
    stroke: "var(--stroke-0, #B78E07)",
    strokeWidth: 0.998051,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.4351 13.2615C36.5499 12.6972 35.5796 12.2792 34.5614 12.0234C33.0335 13.5723 30.9117 14.5341 28.5692 14.5341C26.1975 14.5341 24.0519 13.5481 22.5199 11.9649C18.1311 12.9477 14.8513 16.8664 14.8513 21.5517V23.423C14.8513 24.9733 16.108 26.23 17.6583 26.23H25.1435C25.9186 26.23 26.547 25.6016 26.547 24.8265V24.8259C26.547 24.0511 25.9189 23.423 25.1441 23.423H20.4653C19.6902 23.423 19.0618 22.7946 19.0618 22.0195V19.2521C19.0618 18.4964 19.6426 17.8461 20.3975 17.8106C21.2035 17.7726 21.8688 18.4148 21.8688 19.2125V20.616H25.1435C26.1975 20.616 27.1615 21.0062 27.9008 21.6484C28.3081 21.1687 28.7965 20.7543 29.3545 20.432L37.4577 15.7537L39.2297 14.7306C38.6914 14.172 38.089 13.6789 37.4351 13.2615Z",
    fill: "var(--fill-0, #B78E07)",
    stroke: "var(--stroke-0, #B78E07)",
    strokeWidth: 0.998051,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M28.5692 11.7271C25.4736 11.7271 22.9552 9.20864 22.9552 6.11306C22.9552 3.01748 25.4736 0.499025 28.5692 0.499025C31.6648 0.499025 34.1832 3.01748 34.1832 6.11306C34.1832 9.20864 31.6648 11.7271 28.5692 11.7271Z",
    fill: "var(--fill-0, #B78E07)",
    stroke: "var(--stroke-0, #B78E07)",
    strokeWidth: 0.998051,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill2);
export default __webpack_public_path__ + "static/media/skill-2.931a84cfe8af28db478b37b4b1666d56.svg";
export { ForwardRef as ReactComponent };